import { ICreditLimitsState, ICreditLimits, Types } from './types';
import { Reducer } from 'redux';

const INITIAL_STATE: ICreditLimitsState = {
  loading: false,
  error: false,
  selectedCustomerId: '',
  creditLimits: undefined
};

type CustomAction = {
  type: Types;
  payload: {
    creditLimits: ICreditLimits;
    selectedCustomerId: string;
    alreadyRequested: boolean;
  };
};

const reducer: Reducer<ICreditLimitsState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_CREDIT_LIMITS:
      return {
        ...state,
        loading: true,
        error: false,
        selectedCustomerId: action.payload.selectedCustomerId
      };

    case Types.LOAD_CREDIT_LIMITS_SUCCESS:
      return {
        ...state,
        creditLimits: action.payload.creditLimits,
        loading: false,
        error: false
      };

    case Types.LOAD_CREDIT_LIMITS_FAILURE:
      return { ...state, creditLimits: undefined, loading: false, error: true };

    case Types.REQUEST_RENEW_CREDIT_LIMITS:
      return { ...state, renewCreditLoading: true, renewCreditError: false };
    case Types.REQUEST_RENEW_CREDIT_LIMITS_SUCCESS:
      return {
        ...state,
        renewCreditLoading: false,
        renewCreditError: false,
        renewCreditAlreadyRequested: action.payload.alreadyRequested
      };
    case Types.REQUEST_RENEW_CREDIT_LIMITS_FAILURE:
      return { ...state, renewCreditLoading: false, renewCreditError: true };

    default:
      return state;
  }
};

export default reducer;
